import {
  Box,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useState, useContext } from "react";
import { updateUser } from "@privateid/cryptonets-web-sdk-alpha/dist/apiUtils";

import { useStyles, styles } from "../../../styles/styles";
import { theme as Theme } from "../../../theme";
import { UserContext } from "../../../context/UserContext";
import STEPS from "../../../pages/register/steps";
import MonthPicker from "../../DatePicker";
import CvsButton from "../../Button";
import * as yup from "yup";
import dayjs from "dayjs";

export const personalDetailsSchema = yup.object().shape({
  firstName: yup.string().required("First name is required."),
  lastName: yup.string().required("Last name is required."),
  dob: yup
    .date()
    .nullable()
    .test("dob", "Please enter valid DOB", function (value, ctx) {
      if (!value) return true;
      const valid = dayjs(value).isValid();
      return !valid ? ctx.createError() : valid;
    })
    .typeError("Please enter a valid DOB (MM/DD/YYYY)."),
});
const PersonalDetails = ({
  setStep,
  skin,
  matchesSM,
  setPrevStep,
}: {
  setStep: any;
  skin: string;
  matchesSM: boolean;
  setPrevStep: (e: string) => void;
}) => {
  const classes = useStyles();
  const mainTheme = Theme;
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState();
  const palette: { [key: string]: any } = mainTheme.palette;
  const [formData, setFormData] = useState<any>({});
  const context = useContext(UserContext);
  const { id } = context;

  const onInputChange = (e: any) => {
    const name = e?.target?.name;
    const value = e?.target?.value;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleContinue = async (e?: any) => {
    e?.preventDefault();
    try {
      const isFormValid = await personalDetailsSchema.isValid(formData, {
        abortEarly: false, // Prevent aborting validation after first error
      });
      if (isFormValid) {
        // If form is valid, continue submission.
        setErrors(undefined);
        setPrevStep(STEPS.REGISTER_FORM);
        setLoader(true);
        const updateUserResult: any = await updateUser({
          id,
          // @ts-ignore
          attributes: { preferred: { ...formData } },
        });
        if (updateUserResult?._id) {
          setStep(STEPS.ADDRESS_DETAIL);
          setLoader(false);
        }
      } else {
        // If form is not valid, check which fields are incorrect:
        personalDetailsSchema
          .validate(formData, { abortEarly: false })
          .catch((err) => {
            // Collect all errors in { fieldName: boolean } format:
            const errors = err.inner.reduce(
              (acc: any, error: { path: any; message: any }) => {
                return {
                  ...acc,
                  [error.path]: error.message,
                };
              },
              {}
            );

            // Update form errors state:
            setErrors(errors);
          });
      }
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      <form onSubmit={handleContinue}>
        <Grid style={styles.cardGrid} className={classes.cardGridMobile}>
          <Typography
            component="p"
            textAlign={"center"}
            fontSize={16}
            fontWeight={700}
            lineHeight={1.5}
            mt={3}
            mb={2}
            className={classes.cardInnerHeading}
          >
            Please enter your personal details below.
          </Typography>
          <Box width={"100%"}>
            <TextField
              fullWidth
              id="outlined-basic"
              label="First name"
              type="text"
              color={errors?.["firstName"] ? "error" : "primary"}
              helperText={errors?.["firstName"]}
              placeholder="Your legal first name"
              name="firstName"
              required={true}
              sx={{
                "& .MuiInputBase-input": {
                  backgroundColor: '#fff'
                },
                "& .MuiFormHelperText-contained": {
                  color: "red",
                },
                mt: 2,
                mb: 2,
              }}
              onChange={onInputChange}
            />
            <TextField
              fullWidth
              id="outlined-basic"
              label="Last name"
              type="text"
              color={errors?.["lastName"] ? "error" : "primary"}
              helperText={errors?.["lastName"]}
              required={true}
              placeholder="Your legal last name"
              name="lastName"
              sx={{
                "& .MuiInputBase-input": {
                  backgroundColor: '#fff'
                },
                "& .MuiFormHelperText-contained": {
                  color: "red",
                },
                mt: 0,
                mb: 2,
              }}
              onChange={onInputChange}
            />
            <Box className="datePickerWrap" width="100%">
              <MonthPicker
                value={formData?.dob}
                day={true}
                helperText={errors?.["dob"]}
                setEnrollData={(newValue: any) => {
                  setFormData({
                    ...formData,
                    dob: newValue,
                  });
                }}
              />
            </Box>
          </Box>
        </Grid>
        <Box mb={"52px"}>
          <CvsButton
            skin={skin}
            title={
              loader ? (
                <CircularProgress className={classes.scanLoader} />
              ) : (
                "Continue"
              )
            }
            onClick={() => {
              handleContinue();
            }}
          />
        </Box>
      </form>
    </>
  );
};

export default PersonalDetails;
